<template>
    <div class="min-h-full flex flex-col gap-2">
        <div class="flex justify-start items-center gap-1 w-full">
            <div class="w-2 h-2 rounded-full bg-[#FE5000]"></div>
            <div class="w-9 h-2 rounded-full bg-[#FE5000]"></div>
            <p class="text-xl font-bold pl-2 m-0 text-[#092E87]">Financing</p>
        </div>
        <div>
            <div class="w-full py-2">
                <label class="text-base font-normal text-[#666666] w-full" for="financialInstitution">Financial
                    Institution<span class="ml-1 text-red-500">*</span></label>

                <customDropdown v-model="selectedFinancialInstitutions" :items="financialInstitutes" labelKey="title"
                    valueKey="object" buttonText="Select Type" :button-warpper-class="'relative w-full'"
                    :buttonClass="'!rounded-[10px] border border-[#EFEFEF] flex items-center justify-between px-[10px] !py-[4px] !h-[40px] w-full disabled:bg-[#EFEFEF80]'"
                    :buttonTextClass="[
                        'font-roboto text-[14px]',
                        selectedFinancialInstitutions ? 'text-[#333]' : 'text-[#ccc]'
                    ]" :buttonIconClass="'hidden'"
                    :dropdownListClass="'origin-top-right absolute right-0 mt-2 w-full rounded-md border border-[#EFEFEF] z-20 bg-white'"
                    :dropdownListLIClass="'rounded-md overflow-hidden hover:bg-gray-200'"
                    :dropdownListAnchorClass="'no-underline font-roboto block px-2 py-2 text-sm cursor-pointer text-gray-700 hover:bg-gray-200'"
                    @select="onTypeSelect" :disabled="financialInstitutes.length == 1" />
            </div>

            <div v-if="selectedFinancialInstitutions?.is_payment_link" ref="tab-4"
                class="min-h-full flex flex-col gap-3 mb-[3rem]">
                <div v-if="!linkGenerated" ref="tab-4" class="min-h-full gap-3 pt-[30px]">
                    <p class="text-[14px] font-roboto text-[#333] mb- text-justify tablet:text-center">Click <span
                            class="font-bold">Generate Link</span> to
                        create your secure payment link. Once generated, the link will appear here and can be used to complete checkout using a credit/debit card or to apply for available Stripe financing options.
                    </p>
                    <button @click="generateLinkClicked()"
                        class="m-0  !mt-[20px] block mx-auto rounded-full px-[20px] py-[5px] !border-[1px] border-[#FE5000] text-[#fff] bg-[#FE5000]">Generate
                        Link</button>
                </div>

                <div v-else>
                    <div class="w-full py-1">
                        <p class="text-lg font-normal leading-[20px] mb-[15px] text-[#333333]">Use this
                            payment link to make an online payment. You can get financing through this
                            option.</p>
                    </div>
                    <div
                        class="relative w-full h-[35px] 2xl:h-[42px] rounded-md 2xl:rounded-lg !border !border-[#CCCCCC] bg-[#EFEFEF80]">
                        <input type="text" :value="stripURL"
                            class="w-full h-full p-1.5 2xl:p-2.5 !border-0 outline-none !text-[14px] !rounded-[10px] largeDesktop:text-base !text-[#333333] "
                            disabled>
                        <button @click="copysharelink"
                            class="absolute top-0 -right-[1px] h-full w-[34px] 2xl:w-[42px] rounded-r-md 2xl:rounded-r-lg flex items-center justify-center bg-[#092E87]">
                            <img src="../../assets/images/copy-icon.png" alt="Share Icon"
                                class="w-4 h-4 2xl:w-6 2xl:h-6">
                        </button>
                    </div>

                </div>
            </div>

            <div v-else-if="selectedFinancialInstitutions?.is_other"
                class="w-full py-2 grid grid-cols-1 tablet:grid-cols-3 gap-[15px]">
                <div class="col-span-1 tablet:col-span-2">
                    <label class="text-base font-normal text-[#666666] w-full" for="financialInstitution">Enter
                        Financial
                        Institution Name</label>
                    <div v-if="selectedFinancialInstitutions.is_title_prefilled == '1'" class="m-0 text-[16px] min-h-[40px] font-roboto flex items-center p-[7px] rounded-[7.5px] select-none border-[1px] border-[#ccc] bg-[#efefef] text-[#666]">
                            {{ institute_name }}
                    </div>    
                    <inputComponent v-else ref="instituteName" name="financialInstitution" required
                        placeholder="Enter Financial Institution Name" length="120"
                        error-message="Invalid Financial Institution Name" v-model="institute_name"
                        customClass="!rounded-[10px] !text-base font-medium border border-[#cccccc] outline-none !py-[7px] !px-[10px] w-full rounded-lg placeholder:text-[#cccccc] text-#666666" />
                </div>
                <div class="col-span-1">
                    <label class="text-base font-normal text-[#666666] w-full" for="financialInstitution">
                        Dealer Fee</label>
                    <div class="w-full h-[40px] relative">
                        <span
                            class="absolute left-0 top-0 z-10 w-[40px] h-full rounded-[10px] flex justify-center items-center font-medium text-lg bg-[#092E87] text-white">
                            %
                        </span>
                        <inputComponent ref="dealerFee" name="dealerFee" :required="!$helper.isEmpty(dealerFee)" placeholder="0" length="6" type="text"
                            inputmode="decimal" :regex="/^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?|0(\.\d{1,2})?)$/"
                            error-message="Invalid Dealer Fee" v-model="dealerFee"
                            customClass="!rounded-[10px] !text-base font-medium border border-[#cccccc] outline-none !pl-[50px] !py-[7px] pr-2.5 w-full rounded-lg placeholder:text-[#cccccc] text-#666666" />
                    </div>
                </div>
            </div>

            <div v-else-if="selectedFinancialInstitutions?.is_plan_selectable"
                class="w-full py-3 flex justify-center items-center">
                <button v-if="!selectedPlan" @click="selectPlanClicked"
                    class="w-[130px] h-[40px] flex justify-center items-center font-lato font-medium text-base rounded-full transition-all border-[1px] border-[#092E87] text-[#fff] laptop:text-[#092E87] bg-[#092E87] laptop:bg-white laptop:hover:bg-[#092E87] laptop:hover:text-white">
                    Select Plan
                </button>
                <div class="w-[100%]" v-else>
                    <div
                        class="rounded-[10px] pb-[30px] laptop:pb-2.5 p-[10px] shadow-[0_0_5px_3px_#cccccc6b] relative">
                        <div class="flex items-center justify-between py-2 border-b border-[#EFEFEF]">
                            <h4 class="mb-0 text-[16px] font-medium text-[#092E87]" v-html="selectedPlan.description"></h4>
                            <button @click="selectedPlan = null" class="group focus:outline-none focus:!shadow-[0_0_5px_3px_#cccccc6b] min-w-[30px] min-h-[30px] rounded-full shadow-[0_0_5px_3px_#cccccc6b] flex justify-center items-center transition-all border border-[#FE5000] laptop:border-[#EFEFEF] bg-[#FE5000] laptop:bg-white laptop:hover:!bg-[#FE5000]
                            laptop:relative mobile:absolute right-2.5 -bottom-[15px]">
                                <img src="../../assets/images/trashIcon.png" class="w-[16px] h-[16px] object-contain filter mobile:invert laptop:invert-0 mobile:brightness-0 laptop:brightness-[unset] 
                                    laptop:group-hover:invert laptop:group-hover:brightness-0" />
                            </button>
                        </div>
                        <div
                            class="grid laptop:gap-2 laptop:gap-y-2.5 grid-cols-1 laptop:grid-cols-4 mt-[10px] laptop:mt-[20px]">
                            <div
                                class="mobile:flex laptop:block items-center justify-between py-2 laptop:py-0 border-b laptop:border-b-0 border-[#EFEFEF]">
                                <p class="text-[14px] mb-0 text-[#999999]">Plan No.:</p>
                                <span class="text-[14px] text-[#333333]">{{ selectedPlan.plan_number || "N/A" }}</span>
                            </div>
                            <div
                                class="hidden items-center justify-between py-2 laptop:py-0 border-b laptop:border-b-0 border-[#EFEFEF]">
                                <p class="text-[14px] mb-0 text-[#999999]">Dealer Fee:</p>
                                <span class="text-[14px] text-[#333333]">{{
                                    $helper.formattedPercentage(selectedPlan.dealer_fee) || "N/A" }}</span>
                            </div>
                            <div
                                class="mobile:flex laptop:block items-center justify-between py-2 laptop:py-0 border-b laptop:border-b-0 border-[#EFEFEF]">
                                <p class="text-[14px] mb-0 text-[#999999]">Min Loan Amt:</p>
                                <span class="text-[14px] text-[#333333]">${{
                                    $helper.getFormattedAmount_(selectedPlan.min) }}</span>
                            </div>
                            <div
                                class="mobile:flex laptop:block items-center justify-between py-2 laptop:py-0 border-b laptop:border-b-0 border-[#EFEFEF]">
                                <p class="text-[14px] mb-0 text-[#999999]">Max Loan Amt:</p>
                                <span class="text-[14px] text-[#333333]">${{
                                    $helper.getFormattedAmount_(selectedPlan.max) }}</span>
                            </div>
                            <div
                                class="mobile:flex laptop:block items-center justify-between py-2 laptop:py-0 border-b laptop:border-b-0 border-[#EFEFEF]">
                                <p class="text-[14px] mb-0 text-[#999999]">Interest Rate:</p>
                                <span class="text-[14px] text-[#333333]">{{
                                    $helper.formattedPercentage(selectedPlan.interest_rate) || "N/A" }}</span>
                            </div>
                            <div
                                class="mobile:flex laptop:block items-center justify-between py-2 laptop:py-0 border-b laptop:border-b-0 border-[#EFEFEF]">
                                <p class="text-[14px] mb-0 text-[#999999]">Payment Factor:</p>
                                <span class="text-[14px] text-[#333333]">{{
                                    $helper.formattedPercentage(selectedPlan.payment_factor) || "N/A" }}</span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="rounded-[10px] pb-[30px] p-[10px] shadow-[0_0_5px_3px_#cccccc6b] relative mt-[30px]">
                        <div>
                            <label class="text-base font-normal text-[#666666] w-full" for="financialInstitution">
                                Dealer Fee</label>
                            <div class="w-full h-[40px] relative">
                                <span
                                    class="absolute left-0 top-0 z-10 w-[40px] h-full rounded-[10px] flex justify-center items-center font-medium text-lg bg-[#092E87] text-white">
                                    %
                                </span>
                                <inputComponent ref="dealerPlanFee" name="dealerPlanFee" :required="!$helper.isEmpty(dealerPlanFee)" placeholder="0" length="6"
                                    type="text" inputmode="decimal"
                                    :regex="/^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?|0(\.\d{1,2})?)$/"
                                    error-message="Invalid Dealer Fee" v-model="dealerPlanFee"
                                    customClass="!rounded-[10px] !text-base font-medium border border-[#cccccc] outline-none !pl-[50px] !py-[7px] pr-2.5 w-full rounded-lg placeholder:text-[#cccccc] text-#666666" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <financingModal ref="financingModal" @selected="onPlanSelected" />

            <div v-if="!selectedFinancialInstitutions?.is_payment_link" class="w-full pt-2">
                <label for="consumersignature" class="text-base text-[#666666]">Description</label>
                <textarea id="consumersignature" rows="5" placeholder="Enter your description here" maxlength="255"
                    v-model="description"
                    class="!text-base font-medium border border-[#cccccc] outline-none py-2 px-[10px] w-full rounded-lg placeholder:text-[#cccccc] text-#666666 resize-none"></textarea>
            </div>
        </div>
    </div>

</template>
<script>
import inputComponent from '../../components/partialComponent/inputComponent.vue';
import customDropdown from '../partialComponent/customDropdown.vue';
import financingModal from './financingModal.vue';
import { useToast } from "vue-toastification";
const toast = useToast();
export default {

    props: ['invoiceDetail', 'financialInstitutes', 'callback', 'linkGenerated', 'stripURL'],

    components: {
        inputComponent,
        customDropdown,
        financingModal
    },
    data() {
        return {
            institute_name: '',
            description: '',
            dealerFee: '',
            dealerPlanFee: '',
            selectedFinancialInstitutions: null,
            selectedPlan: null
        }
    },
    computed: {
        validationCheck() {
            const regex = /^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?|0(\.\d{1,2})?)$/
            if (!this.selectedFinancialInstitutions) return false
            if (this.selectedFinancialInstitutions?.is_payment_link) {
                return true
            } else if (this.selectedFinancialInstitutions?.is_other) {
                if (this.$helper.isEmpty(this.institute_name) || !regex.test(this.$helper.isEmpty(this.dealerFee) ? 0 : this.dealerFee)) return false;
                else return true
            } else if (this.selectedFinancialInstitutions?.is_plan_selectable) {
                if (this.$helper.isEmpty(this.selectedFinancialInstitutions) || this.$helper.isEmpty(this.selectedPlan) || !regex.test(this.$helper.isEmpty(this.dealerPlanFee) ? 0 : this.dealerPlanFee)) return false;
                else return true
            } else {
                return true;
            }
        },
    },
    watch: {
        validationCheck: {
            handler(value) {
                this.$emit("validation-change", this.validationCheck)
            },
            immediate: true,
        },

        financialInstitutes: {
            handler(value) {
                if (this.financialInstitutes?.length == 1) {
                    this.selectedFinancialInstitutions = this.financialInstitutes[0]
                    if (this.callback) {
                        this.callback('onTypeSelected', this.selectedFinancialInstitutions)
                    }
                }
            },
            immediate: true,
        }
    },
    methods: {

        onTypeSelect() {
            if (this.callback) {
                this.callback('onTypeSelected', this.selectedFinancialInstitutions)
            }
            if (this.selectedFinancialInstitutions.is_title_prefilled == '1') {
                this.institute_name = "GoodLeap"
            } else {
                this.institute_name = ""
            }
            this.selectedPlan = null
        },
        checkValidation() {
            let isValid = true;
            const refsToValidate = [
                this.$refs.instituteName,
            ];
            let firstInvalidRef = null;
            for (const ref of refsToValidate) {
                if (ref?.validate?.()) {
                    if (!firstInvalidRef) firstInvalidRef = ref;
                }
            }
            if (firstInvalidRef) {
                isValid = false;
            }
            return isValid;
        },

        async getData() {
            if (this.selectedFinancialInstitutions?.is_payment_link) {
                return {
                    institute_name: this.selectedFinancialInstitutions.title,
                    type: 'PaymentLink',
                    institute_id: this.selectedFinancialInstitutions.id
                }
            } else if (this.selectedFinancialInstitutions?.is_other) {
                return {
                    institute_id: this.selectedFinancialInstitutions.id,
                    institute_name: this.institute_name,
                    dealer_fee: this.$helper.isEmpty(this.dealerFee) ? '0' : this.dealerFee,
                    description: this.description
                }
            } else if (this.selectedFinancialInstitutions?.is_plan_selectable) {
                return {
                    institute_id: this.selectedFinancialInstitutions.id,
                    institute_name: this.selectedFinancialInstitutions.title,
                    plan_id: this.selectedPlan.id,
                    dealer_fee: this.$helper.isEmpty(this.dealerPlanFee) ? '0' : this.dealerPlanFee,
                    description: this.description
                }
            } else {
                return {
                    institute_id: this.selectedFinancialInstitutions.id,
                    institute_name: this.selectedFinancialInstitutions.title
                }
            }
        },

        copysharelink() {
            navigator.clipboard.writeText(this.stripURL)
            toast.success("URL copied successfully!");
        },

        onPlanSelected(plan) {
            this.selectedPlan = plan
        },

        selectPlanClicked() {
            this.$refs.financingModal.show(this.selectedFinancialInstitutions.id)
        },

        generateLinkClicked() {
            if (this.callback) {
                this.callback('onGenerateLinkClicked', this.selectedFinancialInstitutions)
            }
        }
    }
}
</script>